import { getIsomorphicConstant } from "./constants-provider";

export const ADOBE_ANALYTICS_SCRIPT_URL = getIsomorphicConstant(
  "ADOBE_ANALYTICS_SCRIPT_URL",
);
export const APP_ENVIRONMENT = getIsomorphicConstant("APP_ENVIRONMENT");
export const BUILD_NUMBER = getIsomorphicConstant("BUILD_NUMBER");
export const AUTH_HOST_SUBDOMAIN_OVERRIDE = getIsomorphicConstant(
  "AUTH_HOST_SUBDOMAIN_OVERRIDE",
);
export const ONE_TRUST_DOMAIN_ID = getIsomorphicConstant("ONE_TRUST_DOMAIN_ID");
export const CLIENT_SECURE_SCRIPT_CONTAINER_DOMAIN = getIsomorphicConstant(
  "CLIENT_SECURE_SCRIPT_CONTAINER_DOMAIN",
);
export const NUANCE_STATIC_ASSETS_URL = getIsomorphicConstant(
  "NUANCE_STATIC_ASSETS_URL",
);
export const NUANCE_TAG_SERVER_NAME = getIsomorphicConstant(
  "NUANCE_TAG_SERVER_NAME",
);
export const MIXPANEL_RECORD_SESSIONS_PERCENT = getIsomorphicConstant(
  "MIXPANEL_RECORD_SESSIONS_PERCENT",
);
export const MY_ACCOUNT_BASE_URL =
  APP_ENVIRONMENT === "prod"
    ? "https://my.topshop.com/my-account"
    : "https://my.asoschameleon.com/my-account";
